var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 13.748,
    viewBox: "0 0 10 13.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_20dc7cecd3ee77854bc6b64716aa9af8",
    "data-name": "20dc7cecd3ee77854bc6b64716aa9af8",
    transform: "translate(-3.999 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1007",
    "data-name": "Caminho 1007",
    d: "M8.442,14.747a.623.623,0,0,1-.619-.694L8.3,9.623H4.624a.625.625,0,0,1-.519-.975l4.93-7.374a.622.622,0,0,1,1.137.387L9.692,6.124h3.681a.625.625,0,0,1,.519.975l-4.93,7.374A.625.625,0,0,1,8.442,14.747Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningFill);
export default __webpack_public_path__ + "static/media/lightning-fill.4602982ca4206aeddc5d9c7d4a8e0b49.svg";
export { ForwardRef as ReactComponent };